import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faCoffee)


new Vue({
  el: '#app',
  components:{FontAwesomeIcon},
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js